import React from 'react'
import Link from 'gatsby-link'
import Img from 'gatsby-image'

import './index.scss'

const PromoItem = props => (
	<li className="homepage--promos--item">
		<a href={props.ctaLink} className="clearfix" target="_blank">
			<div className="homepage--promos--item--text-overlay">
				<h2 dangerouslySetInnerHTML={{__html: props.headline}}></h2>
				<span className="homepage--promos--item--text-overlay--cta">{props.ctaText}</span>
			</div>
			<Img
        title={props.title}
        alt={props.title}
        sizes={props.promoImage.sizes}
      />
		</a>
	</li>
)

export default PromoItem



// WEBPACK FOOTER //
// ./src/components/Promo-Item/index.js